import { useMixpanelTrackers } from "@jidlomat/terminal-core/hooks/useMixpanelTrackers";
import { useAppSelector } from "@jidlomat/terminal-core/hooks/utilsHooks/storeHooks";
import { selectShortFridgeId } from "@jidlomat/terminal-core/slices/fridgeInfoSlice";
import { logToSentry } from "@jidlomat/terminal-core/utils/logger";
import { BasicModal } from "@jidlomat/terminal-ui/components/global/modals/BasicModal";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ErrorModalContent } from "./modalsContents/ErrorModalContent";

const NoActiveSalesPointModalContent = () => {
	const fridgeId = useAppSelector(selectShortFridgeId);
	const { t } = useTranslation();
	const { trackNoActiveSalesPointModal } = useMixpanelTrackers();

	// biome-ignore lint/correctness/useExhaustiveDependencies: intentionally mount/unmount-only for tracking
	useEffect(() => {
		trackNoActiveSalesPointModal("open");
		logToSentry(`No active sales point modal displayed on fridge: ${fridgeId}`, "warning");
		return () => {
			trackNoActiveSalesPointModal("close");
		};
	}, []);

	return (
		<ErrorModalContent
			fridgeId={fridgeId}
			title={t("modals.noActiveSalesPoint.title")}
			body={t("modals.noActiveSalesPoint.body")}
		/>
	);
};

export const NoActiveSalesPointModal = () => (
	<BasicModal modalContent={<NoActiveSalesPointModalContent />} open={true} closable={false} fullHeight={true} />
);
